import marked from 'marked';
import releases from './releases.json';
import changelogRaw from './changelog.json';
import people from './people.json';
import generate from './generate-releases';

marked.setOptions({
  renderer: new marked.Renderer()
});

const peopleList = people.reduce((acc, person) => {
  acc[person.id] = person;
  return acc;
}, {});

const currentLogs = changelogRaw
  .filter(log => !log.old && log.exclusive.toLowerCase() !== 'appliance')
  .sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime());

const changelog = {
  log: currentLogs,
  active: generate().filter(item => !item.old),
  old: generate().filter(item => item.old)
};

export const changelogOldData = {
  changelog: changelog.old,
  people: peopleList,
  capitalizeFirstLetter,
  renderMarkDown
};

export const changelogApplianceData = {
  changelog: changelog.active,
  people: peopleList,
  capitalizeFirstLetter,
  renderMarkDown
};
export const changelogData = {
  people: peopleList,
  capitalizeFirstLetter,
  changelog: changelog.log
};

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function renderMarkDown(md) {
  const html = marked(md);
  return html.replace(/\[/g, '<span class="label label-default">').replace(/\]/g, '</span>');
}



// WEBPACK FOOTER //
// ./src/pages/changelog/data.js